import { action } from "typesafe-actions";
import { Logo, LogoActions } from "./types";

export const fetchAllLogos = () => action(LogoActions.FETCH_ALL);

export const fetchAllLogosSuccess = (data: Logo[]) =>
  action(LogoActions.FETCH_ALL_SUCCESS, data);
